export default function GroupedBarChart({ data, keys, colors, height = 160 }) {
  if (!data?.length) {
    return <p className="text-sm text-slate-400 text-center py-8">Aucune donnée</p>;
  }

  const max = Math.max(
    1,
    ...data.flatMap((d) => keys.map((k) => d[k] ?? 0))
  );

  return (
    <div className="flex items-end gap-1.5" style={{ height }}>
      {data.map((d, i) => (
        <div key={i} className="flex-1 flex flex-col items-center gap-1 min-w-0 group">
          <div className="w-full flex items-end justify-center gap-0.5" style={{ height: height - 28 }}>
            {keys.map((key, ki) => {
              const val = d[key] ?? 0;
              const pct = max > 0 ? Math.max(val > 0 ? 4 : 0, (val / max) * 100) : 0;
              return (
                <div
                  key={key}
                  className={`flex-1 rounded-t-sm transition-all ${colors[ki] ?? "bg-blue-500"}`}
                  style={{ height: `${pct}%` }}
                  title={`${d.month}: ${val}`}
                />
              );
            })}
          </div>
          <span className="text-[9px] text-slate-400 truncate w-full text-center">{d.month}</span>
        </div>
      ))}
    </div>
  );
}